import React, { useState } from "react";
import { Modal, Button, Typography, Tag } from "antd";
import { DownloadOutlined, CloseOutlined } from "@ant-design/icons";
import '../utils/detailsModal.css';
const TransactionModal = ({ visible, onClose, transaction, business }) => {

    const { id, amount, currency, paymentMethod, status, createdAt, phoneNumber, prefixPhone } =transaction || {};

    const returnStatus = (status) => {
        if (status === "SUCCESS") {
            return <Tag color="green"> <span style={{ color: "green" }}>✔️</span> Succès</Tag>
        } else if (status === "REJECTED") {
            return <Tag color="red">❌ Échec</Tag>
        } else {
            return <Tag color="default">❌ Attente</Tag>
        }

    }

    const returnDate = () => {
        if (createdAt) {
            return  new Date(createdAt).toLocaleString('fr-FR', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
              })
        }else {
            return null;
        }
    }

    const returnPhoneNumber = (phoneNumber) => {
        if (phoneNumber) {
            return `+${prefixPhone} ${phoneNumber}`
        } else {
            return <Tag color="default">Non défini</Tag>
        }
    }

    return (
        <Modal
            open={visible}
            onCancel={onClose}
            footer={null}
            closeIcon={<CloseOutlined style={{ fontSize: 18, color: "#FF6B6B" }} />}
        >
            <div style={{ textAlign: "center", padding: 20 }}>
                <Typography.Title level={4} style={{ marginBottom: 20 }}>
                    Information de la transaction
                </Typography.Title>
                <div style={{ textAlign: "left" }}>
                    <div className="element-container">
                        <p><span className="title-element">Entreprise</span><span className="value-element">{business}</span></p>
                    </div>
                    <div className="element-container">
                        <p><span className="title-element">ID</span> <span className="value-element"># {id}</span></p>
                    </div>
                    <div className="element-container">
                        <p><span className="title-element">Date de paiement</span> <span className="value-element">{returnDate()}</span></p>
                    </div>
                    <div className="element-container">
                        <p><span className="title-element">Opérateur</span> <span className="value-element">{paymentMethod}</span></p>
                    </div>
                    <div className="element-container">
                        <p><span className="title-element">N° Téléphone</span> <span className="value-element">{returnPhoneNumber()}</span></p>
                    </div>
                    <div className="element-container">
                        <p><span className="title-element">Montant</span> <span className="value-element">{amount} {currency}</span></p>
                    </div>
                    <div className="element-container">
                        <p>
                            <span className="title-element">Statut</span>
                            <span className="value-element">
                                {returnStatus(status)}
                            </span>
                        </p>
                    </div>

                </div>
                <Button
                    type="primary"
                    icon={<DownloadOutlined />}
                    size="large"
                    style={{
                        width: "100%",
                        marginTop: 20,
                        backgroundColor: "#E0E7FF",
                        color: "#3761FF",
                        border: "none",
                    }}
                >
                    Télécharger le reçu
                </Button>
            </div>
        </Modal>
    );
};

export default TransactionModal;
